import { AuthType, resolveOption } from './utils.js';

function createAuthenticationInterceptor(authConfig = {}) {
  const { type: defaultAuthType = AuthType.NONE, options: defaultOptions = {} } = authConfig;
  async function interceptor(requestConfig) {
    const {
      authentication: {
        type = defaultAuthType,
        options: configOptions = {}
      } = {},
      ...axiosRequestConfig
    } = requestConfig;
    const options = { ...defaultOptions, ...configOptions };
    let authTypeArray = type || defaultAuthType;
    if (authTypeArray === AuthType.NONE)
      return axiosRequestConfig;
    if (!Array.isArray(authTypeArray)) {
      authTypeArray = [authTypeArray];
    }
    await Promise.all(authTypeArray.map(async (authType) => {
      switch (authType) {
        case AuthType.BASIC: {
          const {
            username,
            password
          } = await resolveOption(options.basic, axiosRequestConfig) || {};
          if (username && password) {
            axiosRequestConfig.auth = { username, password };
          }
          break;
        }
        case AuthType.SESSION_TOKEN: {
          const sessionToken = await resolveOption(options.sessionToken, axiosRequestConfig);
          if (sessionToken)
            axiosRequestConfig.headers.Authorization = `Bearer ${sessionToken}`;
          break;
        }
        case AuthType.ACCESS_TOKEN_URL: {
          const accessToken = await resolveOption(options.accessToken, axiosRequestConfig);
          axiosRequestConfig.url = axiosRequestConfig.url?.replace("{accessToken}", accessToken || "");
          break;
        }
        case AuthType.ACCESS_TOKEN_DATA: {
          axiosRequestConfig.data = {
            ...axiosRequestConfig.data,
            token: await resolveOption(options.accessToken, axiosRequestConfig)
          };
          break;
        }
        case AuthType.CONSUMER: {
          const { key, secret } = await resolveOption(options.consumer, axiosRequestConfig) || {};
          axiosRequestConfig.headers["x-consumer-key"] = key;
          axiosRequestConfig.headers["x-consumer-secret"] = secret;
          break;
        }
        case AuthType.SSO_TOKEN: {
          const token = await resolveOption(options.ssoToken, axiosRequestConfig);
          if (token)
            axiosRequestConfig.headers.ssoToken = token;
          break;
        }
      }
    }));
    return axiosRequestConfig;
  }
  return interceptor;
}

export { createAuthenticationInterceptor };
//# sourceMappingURL=axiosInterceptorAuth.js.map
